import { ThemeSchemaResponse } from '@api';
import { TabLines } from '@design/components/tab-lines/TabLines';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { useTranslation } from 'react-i18next';

import { ThemeHeader } from '../../../modules/reflexivity-graph/components/theme-header/ThemeHeader';
import styles from './ThemeOverviewHeader.module.scss';

export type ThemeOverviewHeaderProps = {
  theme: ThemeSchemaResponse;
};

export const THEME_OVERVIEW_CONTENT_ID = 'theme-overview-content';
export const THEME_TAB_COMPANIES = 'companies';

export const ThemeOverviewHeader = ({ theme }: ThemeOverviewHeaderProps) => {
  const { t } = useTranslation('widget');
  const { params, setQueryParams } = useQueryParams();
  const activeTab = params[queryKeys.activeSubTab] || 'overview';

  if (!theme) {
    throw new Error('ThemeOverviewHeader: No theme found');
  }

  const tabs = [
    {
      tabKey: 'overview',
      tabLabel: t('widget:themeOverview.overview'),
    },
    {
      tabKey: THEME_TAB_COMPANIES,
      tabLabel: t('widget:themeOverview.companies'),
    },
    {
      tabKey: 'performance',
      tabLabel: t('widget:themeOverview.performance'),
    },
    {
      tabKey: 'earnings',
      tabLabel: t('widget:themeOverview.earnings'),
    },
  ];

  return (
    <div className={styles.themeHeaderRoot} data-testid="theme-overview-header">
      <div className={styles.innerContainer}>
        <ThemeHeader
          themeId={theme.id}
          themeName={theme.name}
          logo_url={theme.logo_url}
        />
        <TabLines
          tabs={tabs}
          activeTab={activeTab}
          onChange={idx =>
            setQueryParams({ [queryKeys.activeSubTab]: tabs[idx].tabKey })
          }
        />
      </div>
    </div>
  );
};
